export const zhHansGrid = {
        grid: {
                groupPanelEmpty: '托拽列标题到此处按列组合显示',
                pagerInfo: '显示条目 {0} - {1} 共 {2}',
                pagerItemsPerPage: '每页项目',
                noRecords: '没有可用的记录。',
                pagerFirstPage: '转到第一页',
                pagerPreviousPage: '转到上一页',
                pagerNextPage: '转到下一页',
                pagerLastPage: '转到最后一页',
                pagerPage: '页面',
                pagerOf: '的',
                pagerItems: '项目',
                filterEqOperator: '等于',
                filterNotEqOperator: '不等于',
                filterIsNullOperator: '为无',
                filterIsNotNullOperator: '不为无',
                filterIsEmptyOperator: '为空',
                filterIsNotEmptyOperator: '不为空',
                filterStartsWithOperator: '开始于',
                filterContainsOperator: '包含',
                filterNotContainsOperator: '不包含',
                filterEndsWithOperator: '结束于',
                filterGteOperator: '大于等于',
                filterGtOperator: '大于',
                filterLteOperator: '小于等于',
                filterLtOperator: '小于',
                filterIsTrue: '为真',
                filterIsFalse: '为假',
                filterBooleanAll: '(全部)',
                filterAfterOrEqualOperator: '后于或等于',
                filterAfterOperator: '是在之后',
                filterBeforeOperator: '是之前',
                filterBeforeOrEqualOperator: '早于或等于',
                filterTitle: '筛选',
                filterSubmitButton: '筛选',
                filterClearButton: '清除',
                filterAndLogic: '和',
                filterOrLogic: '或',
                sortAscending: '升序排序',
                sortDescending: '降序排列',
                filterCheckAll: '选择所有'
        },
        "calendar": {
                "today": "今天"
        }
}

export const zhHantGrid = {
        grid: {
                groupPanelEmpty: '托拽列標題到此處按列組合顯示',
                pagerInfo: '顯示條目 {0} - {1} 共 {2}',
                pagerItemsPerPage: '每頁項目',
                noRecords: '沒有可用的記錄。 ',
                pagerFirstPage: '轉到第一頁',
                pagerPreviousPage: '轉到上一頁',
                pagerNextPage: '轉到下一頁',
                pagerLastPage: '轉到最後一頁',
                pagerPage: '頁面',
                pagerOf: '的',
                pagerItems: '項目',
                filterEqOperator: '等於',
                filterNotEqOperator: '不等於',
                filterIsNullOperator: '為無',
                filterIsNotNullOperator: '不為無',
                filterIsEmptyOperator: '為空',
                filterIsNotEmptyOperator: '不為空',
                filterStartsWithOperator: '開始於',
                filterContainsOperator: '包含',
                filterNotContainsOperator: '不包含',
                filterEndsWithOperator: '結束於',
                filterGteOperator: '大於等於',
                filterGtOperator: '大於',
                filterLteOperator: '小於等於',
                filterLtOperator: '小於',
                filterIsTrue: '為真',
                filterIsFalse: '為假',
                filterBooleanAll: '(全部)',
                filterAfterOrEqualOperator: '後於或等於',
                filterAfterOperator: '是在之後',
                filterBeforeOperator: '是之前',
                filterBeforeOrEqualOperator: '早於或等於',
                filterTitle: '篩選',
                filterSubmitButton: '篩選',
                filterClearButton: '清除',
                filterAndLogic: '和',
                filterOrLogic: '或',
                sortAscending: '升序排序',
                sortDescending: '降序排列',
                filterCheckAll: '選擇所有'
        },
        "calendar": {
                "today": "今天"
        }
}
export const enGrid = {
        grid: {
                groupPanelEmpty: 'Drag the column title to display by column combination',
                pagerInfo: 'Show entries {0} - {1} of {2}',
                pagerItemsPerPage: 'Items per page',
                noRecords: 'No records available. ',
                pagerFirstPage: 'Go to the first page',
                pagerPreviousPage: 'Go to the previous page',
                pagerNextPage: 'Go to the next page',
                pagerLastPage: 'Go to the last page',
                pagerPage: 'Page',
                pagerOf: 'of',
                pagerItems: 'Items',
                filterEqOperator: 'Equal to',
                filterNotEqOperator: 'Not equal to',
                filterIsNullOperator: 'No',
                filterIsNotNullOperator: 'Not Null',
                filterIsEmptyOperator: 'Is empty',
                filterIsNotEmptyOperator: 'Not empty',
                filterStartsWithOperator: 'starts with',
                filterContainsOperator: 'Contains',
                filterNotContainsOperator: 'Does not contain',
                filterEndsWithOperator: 'Ends at',
                filterGteOperator: 'Greater than or equal to',
                filterGtOperator: 'Greater than',
                filterLteOperator: 'Less than or equal to',
                filterLtOperator: 'Less than',
                filterIsTrue: 'True',
                filterIsFalse: 'Is false',
                filterBooleanAll: '(All)',
                filterAfterOrEqualOperator: 'After or equal to',
                filterAfterOperator: 'Is after',
                filterBeforeOperator: 'Before',
                filterBeforeOrEqualOperator: 'Earlier than or equal to',
                filterTitle: 'Filter',
                filterSubmitButton: 'Filter',
                filterClearButton: 'Clear',
                filterAndLogic: 'And',
                filterOrLogic: 'Or',
                sortAscending: 'Sort ascending',
                sortDescending: 'Sort descending',
                filterCheckAll: 'Select all'
        },
        "calendar": {
                "today": "Today"
        }
}